module.exports = __webpack_public_path__ + "static/media/tire-confirm-img.410ade83.svg";